import qs from 'qs';
import store from '@/store/';
import axios from 'axios';
import config from '@/config';
import { addAuthCookie } from '@/util.js';

/**
 * @description axios 인스턴스 이름 리스트 (추가시 해당 key로 객체를 만들어 export 하며 Vue 인스턴스에서 $붙여 메소드로 사용가능)
 */
const nameList = [
	'axios',
	'axiosAdmin2',
	'axiosAdmin2NoSpinner',
	'axiosSlack',
	'axiosNoah',
	'axiosAuth',
	'axiosSupport',
	'axiosAdminJS',
	'axiosGpt',
	'axiosShortUrl',
];

const baseURLBundle = {
	axiosAdmin2:
		config.env === 'dev'
			? `https://admin-api-j.glowpick.net`
			: `https://admin-api-j.glowpick.com`,
	axiosAdmin2NoSpinner:
		config.env === 'dev'
			? `https://admin-api-j.glowpick.net`
			: `https://admin-api-j.glowpick.com`,
	axiosSlack:
		config.env === 'dev'
			? `https://slack.com/api`
			: `https://slack.com/api`,
	axiosNoah:
		config.env === 'dev'
			? 'https://admin-api-j.glowpick.net/admin-api/v2'
			: 'https://admin-api-j.glowpick.com/admin-api/v2',
	axiosAuth:
		config.env === 'dev'
			? 'https://auth.glowpick.net'
			: 'https://auth.glowpick.com',
	axiosSupport:
		config.env === 'dev'
			? 'https://support.glowpick.net'
			: 'https://support.glowpick.com',
	axiosAdminJS:
		config.env === 'dev'
			? 'https://s143jlzole.execute-api.ap-northeast-2.amazonaws.com/dev'
			: 'https://s143jlzole.execute-api.ap-northeast-2.amazonaws.com/production',
	axiosGpt:
		config.env === 'dev'
			? 'https://lax81j65xe.execute-api.ap-northeast-2.amazonaws.com/dev'
			: 'https://lax81j65xe.execute-api.ap-northeast-2.amazonaws.com/production',
	axiosShortUrl:
		config.env === 'dev'
			? 'https://short-url.glowpick.net'
			: 'https://short-url.glowpick.com',
};

const instBundle = nameList.reduce((bundle, key) => {
	const config = {};
	const baseURL = baseURLBundle[key];
	/**
	 * @description 각 인스턴스의 config 설정
	 */
	bundle[key] = axios.create(config);
	if (key.indexOf('NoSpinner') < 0) {
		bundle[key].interceptors.response.use(
			config => {
				store.commit('toggleSpinner', false);
				return config;
			},
			async err => {
				const originReq = err.config;
				const refresh_token = localStorage.getItem('refresh_token');
				const isRefreshReq =
					originReq.url.indexOf('/public/admin.auth/token/refresh') >
					-1;
				const isLoginReq =
					originReq.url.indexOf('/public/admin.auth/token/login') >
					-1;
				if (
					err.response &&
					(err.response.status === 401 ||
						err.response.status === 403) &&
					!isRefreshReq &&
					!isLoginReq
				) {
					if (refresh_token) {
						const { data } = await bundle.axiosAuth.post(
							'/public/admin.auth/token/refresh',
							{ refresh_token }
						);
						addAuthCookie(data.access_token);
						localStorage.setItem('access_token', data.access_token);
						localStorage.setItem(
							'refresh_token',
							data.refresh_token
						);
						store.commit('login/Authorization', data.access_token);
						if (
							originReq.url.indexOf(
								'/public/auth/admin/token/verify'
							) > -1
						) {
							originReq.data = JSON.stringify({
								jwt: data.access_token,
							});
						} else {
							originReq.headers.Authorization =
								store.getters['login/Authorization'];
						}
						return await axios(originReq);
					} else {
						store.dispatch('login/logout');
						return new Promise(() => {});
					}
				} else {
					if (isRefreshReq) {
						store.dispatch('login/logout');
						return new Promise(() => {});
					}
					store.commit('toggleSpinner', false);
					return Promise.reject(err);
				}
			}
		);
	}
	bundle[key].interceptors.request.use(
		config => {
			if (config.url.indexOf('/api/common/image') > -1) {
				config.timeout = 0;
			}
			switch (key) {
				case 'axiosNoah':
				case 'axiosAdmin2':
				case 'axiosAdmin2NoSpinner':
				case 'axiosAdminJS':
					if (
						(config.method === 'post' || config.method === 'get') &&
						config.params
					) {
						config.paramsSerializer = params =>
							qs.stringify(params, { arrayFormat: 'brackets' });
					}
					config.baseURL = baseURL;
					config.headers = {
						Authorization: store.getters['login/Authorization'],
					};
					break;
				case 'axiosSlack':
					config.baseURL = baseURL;
					config.headers = {
						'Content-type': 'application/x-www-form-urlencoded',
					};
					config.withCredentials = false;
					break;
				case 'axiosGpt':
					if (baseURL) config.baseURL = baseURL;
					config.headers = {
						'x-api-key': 'ba3ec450-5ea2-11ea-bd59-d78dab67a7f9',
					};
					break;
				case 'axiosSupport':
					if (
						(config.method === 'post' || config.method === 'get') &&
						config.params
					) {
						config.paramsSerializer = params =>
							qs.stringify(params, { arrayFormat: 'brackets' });
					}
					config.baseURL = baseURL;
					config.headers = {
						Authorization: store.getters['login/Authorization'],
						'x-api-key': 'ba3ec450-5ea2-11ea-bd59-d78dab67a7f9',
					};
					break;
				case 'axiosAuth':
					if (
						(config.method === 'post' || config.method === 'get') &&
						config.params
					) {
						config.paramsSerializer = params =>
							qs.stringify(params, { arrayFormat: 'brackets' });
					}
					config.baseURL = baseURL;
					config.headers = {
						Authorization: store.getters['login/Authorization'],
						'x-api-key': 'b9d54cc0-5ea5-11ea-b7f9-41b4f2de8659',
					};
					break;
				case 'axiosShortUrl':
					config.baseURL = baseURL;
					config.headers = {
						Authorization: store.getters['login/Authorization'],
					};
					break;
			}
			if (key.indexOf('NoSpinner') < 0) {
				store.commit('toggleSpinner', true);
			}
			return config;
		},
		err => {
			store.commit('toggleSpinner', false);
			return Promise.reject(err);
		}
	);
	return bundle;
}, {});

const init = Vue => {
	nameList.forEach(key => {
		Vue.prototype[`$${key}`] = instBundle[key];
	});
};

export { init as default, instBundle };
